import React from 'react';
import clsx from 'clsx';
import styles from './icon.module.scss';

interface Props extends React.SVGAttributes<SVGSVGElement> {
  mirror: boolean;
}

export const HalfCircleIcon: React.FC<Props> = (props: Props) => {
  const { width = 183, height = 412, mirror, style, className, ...rest } = props;

  return (
    <svg
      role="img"
      aria-hidden="true"
      className={clsx(styles['half-circle-icon'], className)}
      width={width}
      height={height}
      viewBox="0 0 183 412"
      style={{ transform: mirror ? 'scaleX(-1)' : undefined, ...style }}
      {...rest}
    >
      <path d="M154.836 0.987702C116.036 3.53159 80.0372 20.1326 51.7196 48.3785C21.6295 78.4227 3.88186 118.182 1.73726 160.397C-0.516762 204.586 -0.648064 212.547 1.75914 252.043C4.31954 294.017 22.111 333.557 51.8728 363.426C80.1466 391.781 115.861 408.338 154.836 411.014C165.493 411.737 183 412.001 183 412.001V326.802C183 326.802 161.773 325.662 148.227 322.219C116.058 313.995 90.6289 283.271 88.4186 246.758C86.2302 210.814 86.3615 205.968 88.4405 164.849C90.2787 128.555 115.686 98.2036 148.008 89.8263C159.716 86.8 183 85.6157 183 85.6157V0.000849639C183 0.000849639 170.395 -0.0430105 154.836 0.987702Z" />
    </svg>
  );
};

export default HalfCircleIcon;
